import UserCookie from 'vue-cookies'

export default function authRedirect({ next }) {
    const userType          = UserCookie.get('user_type')
    const isLoggedIn        = UserCookie.get('loggedin')
    const isMembExists      = UserCookie.get('usermembn')
    const isProviderExists  = UserCookie.get('provider_id')
    const isCompanyExists   = UserCookie.get('acct_n')
    const isAdminExists     = UserCookie.get('admin_id')

    if (isLoggedIn && isMembExists) {
        return next('/dashboard/info/')
    } else if (isLoggedIn && isProviderExists) {
        return next('/provider/info')
    } else if (isLoggedIn && isAdminExists && userType === 'claims') {
        return next('/admin/claims/ledgers')
    } else if (isLoggedIn && isCompanyExists) {
        return next('/company/info')
    } else if (isLoggedIn && isAdminExists) {
        return next('/admin')
    } else {
        return next()
    }
}
